import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const GeneralResultsChartsDataContext = createContext();

const GeneralResultsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.GENERAL_RESULTS_GENERAL_RESULTS,
            url: 'governanceroom/esus/generalresults/generalresults'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              annualEvolutionServices: data?.annualEvolutionServices ?? [],
              monthlyEvolutionServices: data?.monthlyEvolutionServices ?? []
          }
        : {
              annualEvolutionServices: [],
              monthlyEvolutionServices: []
          };

    return (
        <GeneralResultsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </GeneralResultsChartsDataContext.Provider>
    );
};

export default GeneralResultsChartsDataProvider;
